/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resize-grip': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M170 930L930 170 870 110 110 870zM430 930L930 430 870 370 370 870zM690 930L930 690 870 630 630 870z"/>'
  }
})
